/**
 * Safely decode a URI component a url
 *
 * @param {string} uri - url to be decoded
 * @param {Number} mod - module to decode by: defaults to 0
 * @returns {string} decoded url string
 */
export default function decodeURIComponentSafe(uri, mod = 0) {
  let out = '';
  let i = 0;
  let l;
  let x;

  const arr = uri.split(/(%(?:d0|d1)%.{2})/);
  for (l = arr.length; i < l; i += 1) {
    try {
      x = decodeURIComponent(arr[i]);
    } catch (e) {
      x = mod ? arr[i].replace(/%(?!\d+)/g, '%25') : arr[i];
    }
    out += x;
  }
  return out;
}
